import React, { useContext, useEffect, useState } from "react";
import CustomButton from "../shared/CustomButton";
import appConst from "../Utilities/appConst.json";
import { useSelector } from "react-redux";
import "../styles/footer.css";
import { LanguageContext } from "../context/language/LanguageContext";
import FooterDetialsItems from "./FooterDetialsItems";
import FooterDetialsAccordion from "../Components/FooterDetialsAccordion";

const Footer = () => {
  const languageContext = useContext(LanguageContext);
  const footer = useSelector((state) => state.footer.summary);
  const nextPage = useSelector((state) => state.footer.nextPage);
  const currentPage = useSelector((state) => state.footer.currentPage);
  const beforeContinue = useSelector((state) => state.footer.beforeContinue);
  const btnText = useSelector((state) => state.footer.btnText);
  const isDisable = useSelector((state) => state.footer.isDisable);
  const background = useSelector((state) => state.footer.background);
  const color = useSelector((state) => state.footer.color);
  const isShowUpdated = useSelector((state) => state.loader.isShowUpdated);
  const isFooterShow = useSelector((state) => state.footer.isShow);
  const showPrices = useSelector((state) => state.footer.showPrices);
  const direction = useSelector((state) => state.mode.direction);

  const [total, setTotal] = useState();
  const [redirect, setRedirect] = useState(false);

  const pathsToRedirectArray = [appConst.LUPA_SITE];

  useEffect(() => {
    setRedirect(pathsToRedirectArray.find((path) => path === nextPage));
  }, [nextPage]);

  useEffect(() => {
    setTotal(footer.tempTotal === 0 ? 0 : footer.tempTotal || footer.total);
  }, [footer]);

  return (
    isFooterShow && (
      <div className="flexFooter" dir={direction} data-testid="footer">
        <div
          className="summary_footer"
          data-testid="footer-summary"
        >
          <>
            <div className="desktop">
              <FooterDetialsItems />
            </div>
            <div className="mobile">
              <FooterDetialsAccordion />
            </div>
          </>

          <div className="footer-divider"></div>

          <div className="footer_container_buttom" data-testid="footer-actions">
            {showPrices && total != null && (
              <div className="boxItem" data-testid="footer-summary-total-payment">
                <h3 className="box_itemL" data-testid="footer-summary-total-payment-value">
                  ₪{parseFloat(total).toFixed(2)}
                </h3>
                <h3 className="box_itemR" data-testid="footer-summary-total-payment-label">
                  {languageContext.getTranslation(appConst.TOTAL_PAYMENT)}
                </h3>
              </div>
            )}

            <div className="next_btn">
              <CustomButton
                nextPage={nextPage}
                currentPage={currentPage}
                variant="contained"
                btnText={btnText}
                beforeContinue={beforeContinue}
                redirect={redirect}
                isDisable={isDisable}
                background={background}
                color={color}
                className="footer-marketing-action-button footer-continue-button"
                data-testid="footer-continue-button"
              ></CustomButton>
            </div>
          </div>

          {nextPage === appConst.NINTH_PAGE && (
            <p className="hyp_redirect_notice">
              בלחיצה על "לתשלום", עוברים לאתר ספק הסליקה: "hyp"
            </p>
          )}
        </div>
      </div>
    )
  );
};
export default Footer;
